import { SVG } from '@svgdotjs/svg.js';

export default class SvgPaper {
  constructor(containerId, width, height) {
    const container = typeof containerId === 'string'
      ? document.getElementById(containerId)
      : containerId;

    if (!container) {
      throw new Error(`SvgPaper container not found: ${containerId}`);
    }

    this.draw = SVG().addTo(container).size(width, height);
  }

  rect(x, y, width, height) {
    const el = this.draw.rect(width, height).move(x, y);
    applyShapeDefaults(el);
    return new SvgElement(el);
  }

  text(cx, cy, content) {
    const el = this.draw.plain(String(content));
    el.attr({
      x: cx,
      y: cy,
      fill: '#000000',
      stroke: 'none',
      'font-family': 'Arial',
      'font-size': '10px',
      'text-anchor': 'middle',
      'dominant-baseline': 'central',
    });
    return new SvgElement(el);
  }

  path(d) {
    const el = this.draw.path(d);
    applyShapeDefaults(el);
    return new SvgElement(el);
  }

  image(src, x, y, width, height) {
    const el = this.draw.image(src).move(x, y).size(width, height);
    return new SvgElement(el);
  }

  circle(cx, cy, r) {
    const el = this.draw.circle(r * 2).center(cx, cy);
    applyShapeDefaults(el);
    return new SvgElement(el);
  }

  remove() {
    if (this.draw) {
      this.draw.remove();
      this.draw = null;
    }
  }
}

function applyShapeDefaults(el) {
  el.attr({
    fill: 'none',
    stroke: '#000000',
    'stroke-width': 1,
  });
}

class SvgElement {
  constructor(el) {
    this._el = el;
    this.node = el.node;
    this.id = el.id();
  }

  attr(attrs) {
    if (!attrs) return this;

    const mapped = { ...attrs };
    if ('src' in mapped) {
      mapped['href'] = mapped['src'];
      delete mapped['src'];
    }

    this._el.attr(mapped);
    return this;
  }

  transform(transformStr) {
    if (typeof transformStr === 'string' && transformStr.startsWith('r')) {
      const deg = parseFloat(transformStr.substring(1));
      if (!isNaN(deg)) {
        this._el.rotate(deg);
      }
    }
    return this;
  }

  click(fn) {
    this._el.click(fn);
    return this;
  }

  remove() {
    this._el.remove();
    return this;
  }
}
